﻿import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket: WebSocket;
  private messages = new Subject<string>();

  connect(url: string): void {
    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log('Connected to relay server');
    };

    this.socket.onmessage = (event) => {
      this.messages.next(event.data);
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error', error);
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket closed', event);
    };
  }

  sendMessage(msg: any) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(msg);
    } else {
      console.warn('WebSocket is not open. Cannot send message');
    }
  }

  getMessages(): Observable<string> {
    return this.messages.asObservable();
  }
}